import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserCircleIcon } from '@heroicons/react/24/outline';
import AdminHeader from '../../../shared/components/AdminHeader';
import LoginDetailsForm, { MustChangeLoginNotice } from '../../../shared/components/LoginDetailsForm';
import { useAuth } from '../../../core/providers/AuthProvider';
import { getOwnTeacher, updateOwnLogin } from '../services/teacherService';

// The signed-in teacher's own profile. Their name is kept by the super admin, so only their username
// and password can be changed here. A teacher still on the login they were given is kept here
// (RoleGuard) until they choose their own.
function TeacherProfilePage() {
  const navigate = useNavigate();
  const { mustChangeLogin, markLoginChanged } = useAuth();
  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState('');

  useEffect(() => {
    let mounted = true;
    getOwnTeacher()
      .then((row) => {
        if (!mounted) return;
        if (row) setTeacher(row);
        else setLoadError('No teacher record is linked to this account.');
      })
      .catch((err) => {
        if (mounted) setLoadError(err.message || 'Failed to load your profile');
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="h-dvh w-full flex flex-col bg-appbg overflow-hidden">
      <AdminHeader />

      <div className="flex-1 min-h-0 overflow-y-auto">
        <main className="w-full p-4 lg:w-3/4 lg:mx-auto">
          {loading ? (
            <p className="w-full text-center text-gray-500 py-12">Loading…</p>
          ) : loadError ? (
            <p className="w-full text-center text-red-600 py-12">{loadError}</p>
          ) : (
            <div className="w-full space-y-4">
              {mustChangeLogin && <MustChangeLoginNotice />}

              <section className="bg-white rounded-lg border border-gray-200 p-4">
                <div className="flex flex-col items-center text-center">
                  <UserCircleIcon className="h-24 w-24 text-[#4ea6d0]" aria-hidden="true" />
                  <h2 className="mt-1 text-2xl font-semibold text-[#0b4a71] uppercase">
                    {[teacher.firstname, teacher.middlename, teacher.lastname].filter(Boolean).join(' ')}
                  </h2>
                </div>
              </section>

              <LoginDetailsForm
                username={teacher.username}
                mustChange={mustChangeLogin}
                save={updateOwnLogin}
                onSaved={(username) => {
                  setTeacher((t) => ({ ...t, username }));
                  if (mustChangeLogin) {
                    markLoginChanged();
                    navigate('/dashboard', { replace: true });
                  }
                }}
              />
            </div>
          )}
        </main>
      </div>
    </div>
  );
}

export default TeacherProfilePage;
